import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { persistReducer, persistStore, } from "redux-persist";
import { encryptTransform } from 'redux-persist-transform-encrypt';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import RootReducer from './redux/reducers';
const lcRootKey = "_root";

const persistConfig = {
  key: lcRootKey,
  storage,
  whitelist: [
    "AppReducer",
    "AuthReducer",
    "AvatarReducer",
  ],
  transforms: [
    encryptTransform({
      secretKey: 'mario-client',
      onError: function (error) {
        console.warn("ERROR[encryptTransform]", error.message);
        window?.localStorage?.removeItem(`persist:${lcRootKey}`);
        // window?.location?.reload();
      },
    }),
  ],
};
const persistedReducer = persistReducer(persistConfig, RootReducer);
const middleware = process.env.REACT_APP_ENV === "production" ? [thunk] : [thunk, logger];
export const store = configureStore({
  reducer: persistedReducer,
  middleware: middleware,
});
export const persistor = persistStore(store);